import { h } from 'preact'
import { ProductUpdateType } from '../product-updates-destination/Types'
import ProductUpdateTopicView from '../product-updates-destination/ProductUpdateTopicView'
import TopicFeaturedImage from '../topic-list-view/TopicFeaturedImage'
import TopicHeader from '../topic-list-view/TopicHeader'

type Props = {
  topic: ProductUpdateType
}

const ProductUpdatePreview = ({ topic }: Props) => {
  return (
    <div className='box qa-topic-first-post' data-helper='class-toggle'>
      <TopicHeader
        title={topic.title}
        contentType={topic.contentType}
        publicLabel={topic.publicLabel}
        productAreas={topic.productAreas}
        replies={0}
        views={0}
      />
      {
        topic.featuredImage
          ? <TopicFeaturedImage src={topic.featuredImage} alt={topic.title} />
          : <hr className='seperator m-h m-b-0' />
      }
      <ProductUpdateTopicView
        topic={topic}
        isPreview
        currentPage={1}
      />
    </div>
  )
}

export default ProductUpdatePreview
